import { Inject, Injectable } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { ɵSharedStylesHost as SharedStylesHost } from '@angular/platform-browser';

@Injectable({ providedIn: null })
export class ShadowDomStylesHostService {
    constructor (
        private readonly sharedStylesHost: SharedStylesHost,
        @Inject(DOCUMENT) private readonly doc: Document,
    ) {}

    addShadowRoot (shadowRoot: ShadowRoot): void {
        this.sharedStylesHost.addHost(shadowRoot);
    }

    removeShadowRoot (shadowRoot: ShadowRoot): void {
        this.sharedStylesHost.removeHost(shadowRoot);
    }

    removeDocumentHead (): void {
        this.sharedStylesHost.removeHost(this.doc.head);
    }
}
